const formatter = new Intl.DateTimeFormat('pt-br', {
  dateStyle: 'short',
});

/**
 * Formata uma data (curta, pt-br). Diferente do `Intl...format` cru, NÃO lança
 * "Invalid time value" quando recebe uma data inválida (ex.: `new Date(undefined)`
 * vindo de um campo ausente na resposta da API) — retorna string vazia. Isso
 * evita derrubar o render de quem formata datas de payloads incompletos.
 */
export const formatDate = (date?: Date | number | string | null): string => {
  const d = date instanceof Date ? date : new Date(date ?? NaN);
  return Number.isNaN(d.getTime()) ? '' : formatter.format(d);
};
